module.exports = __webpack_public_path__ + "img/organization-solutions.9cac6a9.svg";